import React from 'react';
import { Box } from 'theme-ui';
import { useTranslation } from 'react-i18next';

import Text from '../../01_atoms/Text/Text';
import Button from '../../01_atoms/Button/Button';

interface Props {
  error?: string;
  loading: boolean;
  onComputerCamera: () => void;
  onIphoneCamera: () => void;
  onWithoutSmartMirror: () => void;
}

function CameraSourceChoice({
  error,
  loading,
  onComputerCamera,
  onIphoneCamera,
  onWithoutSmartMirror,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: '100%', textAlign: 'left' }}>
      <Text variant="h3" sx={{ m: 0 }}>
        {t('smartMirrorCamera.title')}
      </Text>
      <Text variant="h4" sx={{ mt: 2, mb: 5, fontWeight: 'normal' }}>
        {t('smartMirrorCamera.subtitle')}
      </Text>

      <Button
        variant="primary"
        disabled={loading}
        sx={{ width: '100%', mb: 3 }}
        onClick={onComputerCamera}
      >
        {t('smartMirrorCamera.computer')}
      </Button>

      <Button
        variant="whiteBorder"
        disabled={loading}
        sx={{ width: '100%', mb: 2 }}
        onClick={onIphoneCamera}
      >
        {loading
          ? t('smartMirrorCamera.sending')
          : t('smartMirrorCamera.iphone')}
      </Button>
      <Text variant="smallMontserrat" sx={{ mb: 4, textAlign: 'center' }}>
        {t('smartMirrorCamera.ios_only')}
      </Text>

      {error ? (
        <Text sx={{ mb: 3, color: '#da4642', textAlign: 'center' }}>
          {error}
        </Text>
      ) : null}

      <Button
        variant="text"
        disabled={loading}
        sx={{ width: '100%' }}
        onClick={onWithoutSmartMirror}
      >
        {t('smartMirrorCamera.without')}
      </Button>
    </Box>
  );
}

export default CameraSourceChoice;
